import { Close as CloseIcon } from '@mui/icons-material';
import { Dialog, DialogContent, DialogTitle, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { AuditorCompetenceDetail, FileUploader } from '@/common';
import { addFileToAuditorCompetence } from '../../api/addFileToAuditorCompetence';

type FileUploadModalProps = {
  show: boolean;
  setShow: (show: boolean) => void;
  auditorCompetenceDetail: AuditorCompetenceDetail;
};

const FileUploadModal = ({ show, setShow, auditorCompetenceDetail }: FileUploadModalProps) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return (
    <Dialog
      fullScreen={fullScreen}
      open={show}
      onClose={() => setShow(false)}
      aria-labelledby="responsive-dialog-title"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h5">{t('Upload files', { defaultValue: 'Upload files' })}</Typography>
        <CloseIcon sx={{ fontSize: '2rem', cursor: 'pointer' }} onClick={() => setShow(false)} />
      </DialogTitle>
      <DialogContent>
        <FileUploader
          onFileUpload={async (file) => {
            const formData = new FormData();

            formData.append('title', file.file.name);
            formData.append('attachments', file.file);

            // eslint-disable-next-line no-promise-executor-return
            await new Promise((r) => setTimeout(r, 800));

            return addFileToAuditorCompetence({ id: auditorCompetenceDetail.id, formData });
          }}
          onUploadFinished={(allFilesSuccessfullyUploaded) => {
            if (allFilesSuccessfullyUploaded) {
              queryClient.invalidateQueries(['auditor-competences-id', auditorCompetenceDetail.id]);
              setShow(false);
              return;
            }

            queryClient.invalidateQueries(['auditor-competences-id', auditorCompetenceDetail.id]);
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default FileUploadModal;
